import React, { useEffect, useState } from 'react';
import {
  Button,
  TextField,
  InputAdornment,
  Typography,
} from '@material-ui/core';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import { useRootStore } from '../../../../stores/BridgeProvider';
import {
  FlexDiv,
  ModalBox,
  StyledForm,
  ButtonFlex,
  FormRow,
} from '../../../styles/styles';

import { safeFalsy } from '../../../util/UtilFunctions';

const DtvtModal = ({
  dealTransactionId,
  voucherTransactionId,
  handleClose,
}) => {
  const { dealMapperStore } = useRootStore();
  const dtvt = dealMapperStore.dtvt({
    dealTransactionId,
    voucherTransactionId,
  });

  return (
    <Formik
      initialValues={{
        Amount: dtvt.Amount
          ? safeFalsy(parseFloat(dtvt.Amount).toFixed(2))
          : '',
      }}
      onSubmit={async (values, actions) => {
        dealMapperStore.updateDtvt({
          ...dtvt,
          ...values,
        });
        actions.setSubmitting(false);
        handleClose();
      }}
      render={({
        handleBlur,
        handleChange,
        errors,
        handleSubmit,
        values,
        isSubmitting,
        dirty,
      }) => (
        <FlexDiv style={{ marginBottom: '1rem', marginTop: '1rem' }}>
          <Typography variant="h2">Edit Mapping</Typography>
          <ModalBox style={{ justifyContent: 'center' }}>
            <StyledForm onSubmit={handleSubmit}>
              <FormRow>
                <TextField
                  name="Amount"
                  label="Amount"
                  type="number"
                  value={values.Amount}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={errors.Amount}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </FormRow>
              <ButtonFlex>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  size="large"
                  disabled={!dirty || isSubmitting}
                  style={{
                    margin: '5px',
                  }}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => {
                    dealMapperStore.deleteDtvt(dtvt);
                    handleClose();
                  }}
                  color="secondary"
                  style={{
                    margin: '5px',
                  }}
                >
                  Delete
                </Button>
              </ButtonFlex>
            </StyledForm>
          </ModalBox>
        </FlexDiv>
      )}
    />
  );
};

export default DtvtModal;
